import { render, staticRenderFns } from "./TransactionHistoryTab.vue?vue&type=template&id=747b0efe"
import script from "./TransactionHistoryTab.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports